import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AgencyFilterHeaderItem from './AgencyFilterHeaderItem';

const AgencyFilterHeader = ({ categories, onClickItem, activeCategoryId }) => {
  const { t } = useTranslation();
  const filters = categories?.map((item, i) => (
    <AgencyFilterHeaderItem
      onClickHandler={onClickItem}
      key={`_${i}`}
      active={item?.id === activeCategoryId}
      title={item?.pluralName}
      id={item.id}
    />
  ));

  return (
    <div className="agency-filter__header">
      <AgencyFilterHeaderItem
        key={'all'}
        active={activeCategoryId === 'all'}
        onClickHandler={onClickItem}
        title={t('pages.agency.all_categories')}
        id={'all'}
      />
      {filters}
    </div>
  );
};

AgencyFilterHeader.displayName = `Filters`;

AgencyFilterHeader.propTypes = {
  onClickItem: PropTypes.func,
  categories: PropTypes.array,
  activeCategoryId: PropTypes.string
};

export default AgencyFilterHeader;
